import { render } from "./editli1.vue?vue&type=template&id=7bf73f36&scoped=true"
import script from "./editli1.vue?vue&type=script&lang=js"
export * from "./editli1.vue?vue&type=script&lang=js"

import "./editli1.vue?vue&type=style&index=0&id=7bf73f36&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf73f36"]])

export default __exports__